export enum CertificateStatus {
  Created = 'created',
  Inactive = 'inactive',
  Active = 'active',
  TransferInitiated = 'transfer_initiated',
  TransferWaitingConfirmation = 'transfer_waiting_confirmation',
  WaitingAccept = 'waiting_accept',
  CancelRequest = 'cancel_request',
  Lost = 'lost',
  Stolen = 'stolen',
}
